import { useSyncExternalStore } from 'react';
import { getRouterPathnameSnapshot, subscribeRouter } from './routerStore';

export function useAppPathname(): string {
  return useSyncExternalStore(
    subscribeRouter,
    getRouterPathnameSnapshot,
    () => getRouterServerPathname(),
  );
}

function getRouterServerPathname(): string {
  return '/';
}
